module.exports = __webpack_public_path__ + "img/smartbooks_logo.5a885555.png";